var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("AprobarPermiso"),
      _vm._v(" "),
      _c("RechazarPermiso"),
      _vm._v(" "),
      _c("VerPermisoJefe"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { info: "" } }, [_vm._v("exit_to_app")]),
          _vm._v(
            "Listado de papeletas con solicitud a cargo de vacación-Superior jerarquico \n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("crud-table", {
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  filters: _vm.filters,
                  graphql: _vm.graphql,
                  "data-graphql": _vm.dataGraphql,
                  widthModal: 840,
                  initData: _vm.initData
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", [_vm._v(_vm._s(items.item.numero))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.nombres))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.fecha_emision))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.fecha_desde))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.fecha_retorno))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.estado_permiso))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(items.item.horas_permiso))]),
                        _vm._v(" "),
                        !items.item.nro_dias
                          ? _c("td", [_vm._v("0")])
                          : _vm._e(),
                        _vm._v(" "),
                        items.item.nro_dias
                          ? _c("td", [_vm._v(_vm._s(items.item.nro_dias))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "info",
                                  icon: "",
                                  title: "Ver permiso"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verPermisoJefe(items.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            ),
                            _vm._v(" "),
                            items.item.id_estado == 6 ||
                            items.item.id_estado == 21
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "success",
                                      icon: "",
                                      title: "Aprobar permiso"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.aprobarPermiso(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("done")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado == 6 ||
                            items.item.id_estado == 21
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#E61C5B",
                                      icon: "",
                                      title: "Rechazar permiso"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.rechazarPermiso(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("close")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c58d0da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c58d0da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/papeleta_vacacion/AprobacionPapeletaVacacionJefeSuperior.vue
// module id = null
// module chunks = 